export default {
  membershipValidity: {
    serviceStatus: '服务状态',
    pendingActivation: '待激活',
    renewed: '已续约',
    effectiveFrom: '预计 {date} 起生效',
    details: '查看详情',
  },
};
